import React from "react";
import { Card } from "reactstrap";
import { Button, Tag } from "antd";
import { InfoWindow } from "react-google-maps";

export class CarMarker extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { marker, index } = this.props;

    return (
      <InfoWindow onCloseClick={() => this.props.handleOpenMarker(index)}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "start",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 8,
              padding: "16px 20px",
            }}
          >
            <h6 style={{ margin: 0 }}>{marker.name}</h6>
            {marker.id === 4 && <Tag color="green">John Arley</Tag>}
            {marker.id === 5 && <Tag color="green">Ivan Arjona</Tag>}
            {marker.id === 2 && <Tag color="green">Sin referencia</Tag>}
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <p style={{ margin: "6px" }}>Última actualización:</p>
            <Tag bordered={false}>{marker.lastUpdate}</Tag>
          </div>
        </div>
      </InfoWindow>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/HomeVisits/components/CarMarker.jsx